import {dashboardStatuses} from 'constants/dashboard'
import {formatDate, formatDateForServer} from 'store/slices/api/utils'
import {useGetPlannerActivitiesQuery} from 'store/Store'
import moment from 'moment'

const formatRequest = (request) => ({
    name: request.ClientName,
    approvalDate: formatDate(request.RequestEnded),
    id: request.PlannerClientKey,
})

const filterDataByStatus = (data, status) =>
    data?.filter(({Status}) => Status === status) || []

const getTableData = (requests) => {
    const tableData = {}
    dashboardStatuses.forEach(
        (status) =>
            (tableData[status] = filterDataByStatus(requests, status).map(
                formatRequest
            ))
    )
    return tableData
}

const getTimesInPeriod = (from, to, step = 'days') => {
    let d = moment(from)
    const times = []
    while (!d.isAfter(to)) {
        times.push(formatDate(d))
        d = d.add(1, step)
    }
    return times
}

const countRequestsPerTime = (time, step, requests) => {
    const relevantRequests = requests?.filter(({RequestCreat}) => {
        const mTime = moment(time, 'DD-MM-YYYY')
        const inRange =
            moment(RequestCreat).isSameOrAfter(mTime) &&
            moment(RequestCreat).isBefore(mTime.add(1, step))

        return inRange
    })

    const counts = {name: time}
    dashboardStatuses.forEach(
        (status) =>
            (counts[status] = filterDataByStatus(
                relevantRequests,
                status
            )?.length)
    )

    return counts
}

const getChartData = (from, to, requests, step = 'days') => {
    const times = getTimesInPeriod(from, to)

    const chartData = []
    times.forEach((time) =>
        chartData.push(countRequestsPerTime(time, step, requests))
    )

    return chartData
}

const useActivities = (period) => {
    const {from, to} = period
    const {data: activities, isLoading} = useGetPlannerActivitiesQuery({
        from: formatDateForServer(from),
        to: formatDateForServer(to),
    })

    const {plannerRequests: requests, status, subscription} = activities || {}

    const tableData = getTableData(requests)

    const chartData = getChartData(from, to, requests)

    return {
        status,
        tableData,
        chartData,
        subscription,
        isLoading,
    }
}

export default useActivities
